export const GettingStartedDocUrl = 'https://docs.pinwheelapi.com/docs/getting-started';
export const DocumentationUrl = 'https://docs.pinwheelapi.com/docs';

export const DepositSwitchDocUrl = 'https://docs.pinwheelapi.com/docs/product-deposit-switch';
export const WebhooksDocUrl = 'https://docs.pinwheelapi.com/docs/webhooks-1';
